import React, { useState } from 'react';
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItemIcon,
  ListItemText,
  useTheme,
  useMediaQuery,
  ListItemButton,
  Divider,
  Typography,
  Collapse,
  Badge,
} from '@mui/material';
import {
  Lock as LockManagerIcon,
  Menu as MenuIcon,
  Home as HomeIcon,
  People as PeopleIcon,
  Category as CategoryIcon,
  Business as BusinessIcon,
  Person as PersonIcon,
  Description as DescriptionIcon,
  Security as SecurityIcon,
  Settings as SettingsIcon,
  DocumentScanner as DocumentScannerIcon,
  ExpandLess,
  ExpandMore,
  Flag as FlagIcon,
  TrendingUp as TrendingUpIcon,
} from '@mui/icons-material';

import BadgeIcon from '@mui/icons-material/Badge';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../contexts/AuthContext';
import { text } from 'stream/consumers';
import { MenuItems } from '../shared/MenuItems';

const drawerWidth = 240;

const menuItems = [
  { text: 'Início', icon: <HomeIcon />, path: '/' },
  { text: 'Clientes', icon: <PersonIcon />, path: '/clientes' },
  { text: 'Prospecção', icon: <CalendarMonthIcon />, path: '/visitas-prospeccao' },
  { text: 'Apólices', icon: <DescriptionIcon />, path: '/apolices' },
  { text: 'Lançamentos', icon: <MonetizationOnIcon />, path: '/financeiro' },
  { text: 'Metas', icon: <FlagIcon />, path: '/metas' },
  // { text: 'Desempenho', icon: <TrendingUpIcon />, path: '/desempenho' },
  { text: 'Relatórios', icon: <DocumentScannerIcon />, path: '/relatorios' },
  { text: 'Credenciais', icon: <LockManagerIcon />, path: '/credenciais' },
 

  
];

const configItems = [
 { text: 'Agências', icon: <BusinessIcon />, path: '/agencias' },
 { text: 'Coberturas', icon: <CategoryIcon />, path: '/coberturas' },
 { text: 'Colaboradores', icon: <PeopleIcon />, path: '/usuarios' },
 { text: 'Usuários', icon: <PeopleIcon />, path: '/acessos' },
 { text: 'Empresas', icon: <BusinessIcon />, path: '/empresas' },
 { text: 'Ramos', icon: <CategoryIcon />, path: '/ramos' },
 { text: 'Seguradoras', icon: <SecurityIcon />, path: '/seguradoras' },
 { text: 'Cargos', icon: <BadgeIcon />, path: '/cargos' }
 
 
 
 
];

const getMenuItems = (user:any) => {
  console.log("exibindo usuarios")
  console.log(user)
  const permissoesDeVisualizacao = [
    // permissões vindas dos cargos
    ...(user.cargos ?? []).flatMap((cargo:any) =>
      (cargo.permissoes ?? []).filter(
        (permissao:any) => permissao.acao === "can_read"
      )
    ),

    // permissões avulsas do usuário
    ...(user.permissoes ?? []).filter(
      (permissao:any) => permissao.acao === "can_read"
    )
  ];

  console.log(permissoesDeVisualizacao)
    if (!user.isAdmin) {
      const entidadesPermitidas = new Set(
        permissoesDeVisualizacao.map(p => p.entidade)
      );

      return MenuItems.filter(item =>
        item?.entidade === null || entidadesPermitidas.has(item.entidade)
      );
    }

    return MenuItems;
};

const Header: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuthContext();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleConfigToggle = () => {
    setConfigOpen(!configOpen);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isConfigActive = configItems.some(item => location.pathname === item.path);

  const drawer = (
    <Box 
      sx={{ 
        width: drawerWidth, 
        height: '100vh', 
        bgcolor: '#0d1c3f', 
        color: '#fff', 
        display: 'flex', 
        flexDirection: 'column',
        overflow: 'hidden'
      }} 
      role="presentation" 
      onClick={() => isMobile && setMobileOpen(false)}
    >
      <Box sx={{ p: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
        <img src="/assets/gm-menu-logo.svg" alt="GM Corretora" style={{ maxWidth: '100%', width: '100%', height: 'auto', maxHeight: '60px' }} />
      </Box>
      <Divider sx={{ bgcolor: 'rgba(255,255,255,0.15)', flexShrink: 0 }} />
      <List sx={{ flexGrow: 1, overflow: 'auto' }}>
        {getMenuItems(user).map((item) => (
          <ListItemButton
            key={item.text}
            onClick={() => {
              navigate(item.path);
              if (isMobile) {
                setMobileOpen(false);
              }
            }}
            selected={location.pathname === item.path}
            sx={{ color: '#fff', '&:hover': { bgcolor: 'primary.dark' } }}
          >
            <ListItemIcon sx={{ color: '#fff' }}>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItemButton>
        ))}
        
        {user?.isAdmin && (
          <>
            <Divider sx={{ bgcolor: 'rgba(255,255,255,0.15)', my: 1 }} />
            <ListItemButton
              onClick={handleConfigToggle}
              selected={isConfigActive}
              sx={{ color: '#fff', '&:hover': { bgcolor: 'primary.dark' } }}
            >
              <ListItemIcon sx={{ color: '#fff' }}>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Configurações" />
              {configOpen ? <ExpandLess sx={{ color: '#fff' }} /> : <ExpandMore sx={{ color: '#fff' }} />}
            </ListItemButton>
            <Collapse in={configOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {configItems.map((item) => (
                  <ListItemButton
                    key={item.text}
                    onClick={() => {
                      navigate(item.path);
                      if (isMobile) {
                        setMobileOpen(false);
                      }
                    }}
                    selected={location.pathname === item.path}
                    sx={{ 
                      color: '#fff', 
                      pl: 4,
                      '&:hover': { bgcolor: 'primary.dark' },
                      '&.Mui-selected': {
                        bgcolor: 'rgba(255,255,255,0.1)',
                        '&:hover': { bgcolor: 'rgba(255,255,255,0.15)' }
                      }
                    }}
                  >
                    <ListItemIcon sx={{ color: '#fff' }}>{item.icon}</ListItemIcon>
                    <ListItemText primary={item.text} />
                  </ListItemButton>
                ))}
              </List>
            </Collapse>
          </>
        )}
      </List>
      <Divider sx={{ bgcolor: 'rgba(255,255,255,0.15)', flexShrink: 0 }} />
      <Box sx={{ p: 2, flexShrink: 0 }}>
        <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
          <AccountCircleIcon sx={{ mr: 1, color: '#fff' }} />
          <Typography variant="body1" sx={{ color: '#fff' }}>
            {user?.nome || 'Usuário'}
          </Typography>
        </Box>
        <ListItemButton
          onClick={handleLogout}
          sx={{ 
            color: '#fff', 
            '&:hover': { bgcolor: 'primary.dark' },
            borderRadius: 1,
            pl: 0
          }}
        >
          <ListItemIcon sx={{ color: '#fff', minWidth: 40 }}>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText primary="Sair" />
        </ListItemButton>
        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.5)', display: 'block', textAlign: 'center', mt: 2 }}>
          v1.0.4
        </Typography>
      </Box>
    </Box>
  );

  return (
    <>
      {isMobile && (
        <IconButton
          color="primary"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ position: 'fixed', top: 16, left: 16, zIndex: theme.zIndex.drawer + 2 }}
        >
          <MenuIcon />
        </IconButton>
      )}
      
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
            overflow: 'hidden'
          },
        }}
      >
        {drawer}
      </Drawer>
      
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', sm: 'block' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
            overflow: 'hidden',
            position: 'fixed',
            height: '100vh'
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    </>
  );
};

export default Header; 